import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';

import type { ProductId } from '../../../services/modal-data/types';

/** Keep the Confluence-only modal additions scoped to the Switcher experiment cohort. */
export const isConfluenceWithoutJiraEnabled = (userProducts: readonly ProductId[]): boolean =>
	userProducts.includes('confluence') &&
	!userProducts.includes('jira') &&
	FeatureGates.checkGate('twcg-2683-twc-switcher-rec-confluence-gate');
